import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { authEmployeeQuery } from "modules/auth/lib/authEmployeeQuery"
import { DataResponse, UpdateEmployeeSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof UpdateEmployeeSchema>>

type Props = z.infer<typeof UpdateEmployeeSchema>

export function useUpdateEmployeeMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (props: Props = {}) => {
      const response = await axios.put<Response>(`/employees`, props)

      return response.data.data
    },
    onSuccess: () => queryClient.fetchQuery({ ...authEmployeeQuery(true), staleTime: 0 }),
  })
}
